export enum ProviderOnboardingStep {
  ACCOUNT_DETAILS = 1,
  SHIFT_PREFERENCES = 2,
  TEXT_NOTIFICATIONS = 3,
  PUSH_NOTIFICATIONS = 4,
  UPLOAD_DOCUMENTS = 5,
  WELCOME = 6,
  LICENSES = 7,
}
